"use strict";

module.exports = function (accumulator, order, product, component, options) {
  if (!options.customFunctions.customProductType) {
    throw new Error("customProductType must have a matching entity at ".concat(component.type, ".customFunctions.customProductType"));
  }

  return accumulator + options.customFunctions.customProductType;
};